/**
 * Controller for the component inspector bookmarklet.
 * @constructor
 * @extends {Foundation.API}
 * @param {string} componentId
 */
Foundation.Dev.ComponentInspector = function (componentId, componentMedia) {
    var layoutId = jQuery('meta[name="layout"]').attr('content') || ""

    var layoutMedia = 'Screen'
    if (Foundation.RESPONSIVE !== undefined && Foundation.RESPONSIVE === true) {
        layoutMedia = 'Responsive'
    }
    else if (Foundation.MOBILE !== undefined && Foundation.MOBILE === true) {
        layoutMedia = 'Mobile'
    }

    if (componentMedia) {
        Foundation.API.call(this, "GET", "Component", {
            "id": componentId,
            "layoutId": layoutId,
            "layoutMedia": layoutMedia,
            "componentMedia": componentMedia,
        });
    }
    else {
        Foundation.API.call(this, "GET", "Component", {
            "id": componentId,
            "layoutId": layoutId,
            "layoutMedia": layoutMedia
        });
    }

    var spinner = new Foundation.View.Spinner();
    this.always(spinner.hide.bind(spinner));

    this.then(function () {
        var html = `<div class="uk-padding">
                    Component:
                    <a class="uk-text-bold"
                       href='${this.get("editLink")}' target="_blank">${this.get("name")}</a>
                    <br>
                    ${this.get("uri")}`;

        var presentation = this.get("presentation");
        if (presentation) {
            html += `<hr>
                     Presentation:
                     <a class="uk-text-bold" 
                        href='${presentation["editLink"]}' target="_blank">${presentation["name"]}</a>
                     <br>
                     ${presentation["uri"]}`;
        }

        var layout = this.get("layout");
        if (layout) {
            html += `<hr>
                     Layout:
                     <a class="uk-text-bold"
                        href='${layout["editLink"]}' target="_blank">${layout["name"]}</a>`;
        }

        html += "</div>";

        new Foundation.View.ModalDialog(jQuery(html));
    }.bind(this));
};
Foundation.inherit(Foundation.Dev.ComponentInspector, Foundation.API);

/**
 * Bookmarklet function. Sets up the click event listener on the page, and
 * the crosshair cursor.
 */
Foundation.Dev.ComponentInspector.start = function () {
    jQuery(document.body).append("<div id='ComponentInspectorStyles'><style>*,a {cursor:crosshair}</style></div>");
    jQuery(document).click(Foundation.Dev.ComponentInspector.handleClick);
};

/**
 * Handle the user clicking on or on a child element of a component, so that
 * we can try to invoke the inspector.
 * @private
 */
Foundation.Dev.ComponentInspector.handleClick = function (e) {
    e.stopImmediatePropagation();
    e.preventDefault();

    Foundation.Dev.ComponentInspector.attemptInspection(jQuery(e.target));

    jQuery("#ComponentInspectorStyles").remove();
    jQuery(document).unbind("click", Foundation.Dev.ComponentInspector.handleClick);
};

/**
 * Recursive function for trying to invoke the inspector.
 * @private
 * @param {jQuery} elem
 * @param {number=} attempts
 */
Foundation.Dev.ComponentInspector.attemptInspection = function (elem, attempts) {
    if (!attempts) attempts = 0;

    var candidateComponentDiv = elem.closest("div[id]");

    if (attempts >= 5 || candidateComponentDiv.length === 0) {
        window.alert("Sorry! Failed to find the component!");
        return;
    }

    var inspector = new Foundation.Dev.ComponentInspector(candidateComponentDiv.identify());

    // Keep trying if we failed to find the component based on the ID.
    inspector.otherwise(function () {
        var candidateParent = candidateComponentDiv.parent();
        Foundation.Dev.ComponentInspector.attemptInspection(candidateParent, attempts + 1);
    });
};

// ---------------------------------------------------------------------

window["Foundation"]["Dev"]["ComponentInspector"] = Foundation.Dev.ComponentInspector;
window["Foundation"]["Dev"]["ComponentInspector"]["start"] = Foundation.Dev.ComponentInspector.start;
